export const checkErrorHasTime = (error: string | Element) => {
  return typeof error === 'string' && error.match(/\{(.*)\}/i);
};
